<template>
  <div>
    <va-modal
      class="modal activity"
      v-model="showCreateFormateur"
      cancelClass="none"
      :okText="idformation_formateurs ? 'Modifier un formateur' : 'Ajouter un formateur'"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="saveFormateur"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
    >
      <div>
        <div class="row row-inside">
          <div class="flex md12 pa-2">
            <va-select
              label="Titre"
              textBy="titre"
              keyBy="titre"
              v-model="newFormateur.titre"
              :options="listTitre"
            />
          </div>
          <div class="flex md12 pa-2">
            <va-input
              label="Nom"
              v-model="newFormateur.nom"
            />
          </div>
          <div class="flex md12 pa-2">
            <va-input
              label="Prénom"
              v-model="newFormateur.prenom"
            />
          </div>

        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["value", "idformation_formateurs"],
  data() {
    return {
      listTitre: [
        { titre: "Monsieur" },
        { titre: "Madame" },
      ],
      showCreateFormateur: false,
      newFormateur: {
        nom: null,
        prenom: null,
        titre: "",
      }
    };
  },
  mounted() {
    this.resetForm();
    this.showCreateFormateur = this.value;
  },
  watch: {
    value() {
      this.showCreateFormateur = this.value;
      if (this.idformation_formateurs) {
        // load formateur data
        this.loadFormateur();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    async loadFormateur() {
      try {
        const response = await axios.get("/api/afpf/get-formateur", {
          params: { idformation_formateurs: this.idformation_formateurs }
        });
        this.newFormateur.nom = response.data.nom;
        this.newFormateur.prenom = response.data.prenom;
        let titre = this.listTitre.find(t => t.titre === response.data.titre);
        this.newFormateur.titre = titre ? titre : this.listTitre[0];
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement du formateur");
        return
      }
    },
    resetForm() {
      this.newFormateur = {
        nom: null,
        prenom: null,
        titre: ""
      };
    },
    async saveFormateur() {
      console.log("saveFormateur");
      // todo: complete sanity checks
      if (this.newFormateur.nom == null) {
        this.launchEpicmaxToast("Le nom du formateur est obligatoire");
        this.closeModal();
        return
      } else if (this.newFormateur.prenom == null) {
        this.launchEpicmaxToast("Le prénom du formateur est obligatoire");
        this.closeModal();
        return
      } else if (this.newFormateur.titre == null) {
        this.launchEpicmaxToast("Le titre du formateur est obligatoire");
        this.closeModal();
        return
      }

      let formateur = {
        nom: this.newFormateur.nom,
        prenom: this.newFormateur.prenom,
        titre: this.newFormateur.titre.titre,
      };
      if (this.idformation_formateurs) {
        formateur.idformation_formateurs = this.idformation_formateurs;
        try {
          const response = await axios.put("/api/afpf/update-formateur", formateur);
          this.launchEpicmaxToast("Formateur modifié avec succès");
          this.$emit("update");
          this.closeModal();
        } catch (error) {
          console.log(error);
          this.launchEpicmaxToast("Erreur lors de la modification du formateur");
          this.closeModal();
          return
        }

      } else {
        formateur.idformation_formateurs = null;
        try {
          const response = await axios.post("/api/afpf/create-formateur", formateur);
          this.launchEpicmaxToast("Formateur ajouté avec succès");
          this.$emit("create");
          this.closeModal();
        } catch (error) {
          console.log(error);
          this.launchEpicmaxToast("Erreur lors de l'ajout du formateur");
          this.closeModal();
          return
        }
      }
      // todo : emit id nouveau formateur
      // todo : prevent close if error

    },
    closeModal() {
      this.showCreateFormateur = false;
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },

  },

}
</script>

<style>
.forcewidth-inside {
  width: 40vw;

  overflow: auto;
}
</style>